import React, { FC } from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacer-XS);
    background-color: white;
    border: var(--border-thin) solid var(--appLigthGrey);
    border-radius: 0.5rem;
    font-size: 1rem;
    font-weight: 500;
    color: var(--text-body);
    cursor: pointer;
    transition: background-color 0.2s;
    margin-bottom: var(--spacer-S);

    &:hover {
        background-color: var(--bg-hover-light);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

const FacebookIcon = styled.svg`
    width: 1.5rem;
    height: 1.5rem;
`;

interface FacebookSignInButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

export const FacebookSignInButton: FC<FacebookSignInButtonProps> = ({ onClick, disabled }) => {
    return (
        <StyledButton onClick={onClick} disabled={disabled} type="button">
            <FacebookIcon viewBox="0 0 24 24">
                <path fill="#1877F2" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </FacebookIcon>
            Continue with Facebook
        </StyledButton>
    );
};
